/* Review reveal JavaScript */
const reviewReveal = document.querySelector(".review-reveal");

if (reviewReveal){
    const triggers = reviewReveal.querySelectorAll(".review-reveal__trigger");
    const blocks = reviewReveal.querySelectorAll(".review-reveal__block");

    triggers.forEach(currentTrigger => {
        currentTrigger.addEventListener("click", () => {
            // Update triggers
            triggers.forEach(trigger => {
                trigger.classList.remove("active");
            });

            currentTrigger.classList.add("active");

            // Update blocks
            blocks.forEach(block => {
                if (block.dataset.id == currentTrigger.dataset.id){
                    block.classList.add("active");
                } else {
                    block.classList.remove("active");
                }
            });
        });
    });
}